import {AbstractControl} from '@angular/forms';
export class PasswordValidation {

    static MatchPassword(AC: AbstractControl) {
       let password = AC.get('newpassword').value; // to get value in input tag
       let confirmPassword = AC.get('confirmpassword').value; // to get value in input tag
        
        if(password != confirmPassword) {
            console.log('false');
            AC.get('confirmpassword').setErrors( {MatchPassword: true} )
        } else {
            console.log('true');
            return null
        }
    }
    static lengthPassword(AC: AbstractControl) {
       let password = AC.get('newpassword').value; // to get value in input tag
       
        if(password < 6) {
            console.log('false');
            AC.get('newpassword').setErrors( {lengthPassword: true} )
        } else {
            console.log('true');
            return null
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/admin/shared/components/password-validation.ts